import React from "react";
import { useCookies } from "react-cookie";
import apiList from "services/apiList";
import { callApi } from "services/callApi";
import {
  getSessionStorage,
  removeSessionStorage,
  setSessionStorage,
} from "utils/storageUtil";
import { deleteAllCookies } from "../utils/helperFunctions";

const UserContext = React.createContext();

const UserProvider = (props) => {
  const [cookies, setCookie] = useCookies(["kioskUser"]);

  function onLogin() {
    setCookie("kioskUser", JSON.stringify({ isLoggedIn: true }), {
      path: "/",
    });
  }

  async function onLogout() {
    if (!cookies?.kioskUser) {
      return;
    }
    try {
      const logoutResponse = await callApi.put(apiList.logout);
      console.log(logoutResponse);
      if (logoutResponse?.status === 200) {
        deleteAllCookies();
        removeSessionStorage("guestUserData");
      }
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <UserContext.Provider
      value={{
        onLogin,
        onLogout,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider };
